import { useMutation } from '@tanstack/react-query';
import useGlynt from '../useGlynt';
import { IRQCallbacks } from '../../../types/my-types';
import { IPartialPackage } from '../../../types/packager-types';

type IUsePackageUpdateProps = {
  packageId: string;
  data: IPartialPackage;
};

export const usePackageUpdate = (callbacks?: IRQCallbacks) => {
  const glynt = useGlynt();

  return useMutation({
    mutationFn: async (data: IUsePackageUpdateProps) => {
      return await (await glynt).packages.update(data.packageId, data.data);
    },

    ...callbacks
  });
};
